.nav {
  position: sticky;
  z-index: 100;
  top: 0;
  display: flex;
  height: 3rem;
  align-items: center;
  justify-content: space-between;
  background-color: var(--container);

  .left {
    width: 48px;
  }

  .right {
    width: 48px;
  }
}
